@if (!appService.isEnterpriseChild) {
  <div class="container forceDefaultColors">
    <div class="logoContainer">
      <div class="autentique-logo">
        <img src="assets/logo-and-text-white.png" alt="" />
      </div>

      @if (backToRegister) {
        <a routerLink="/cadastro" queryParamsHandling="preserve" class="create-link">{{ 'auth.dontHaveAcc' | translate }}</a>
      } @else {
        <a routerLink="/entrar" queryParamsHandling="preserve" class="create-link">{{ 'auth.alreadyHaveAcc' | translate }}</a>
      }
    </div>

    <div class="create-terms">
      <a [href]="appService.termsOfUseAddress" class="create-terms-item">{{ 'external.useTerm' | translate }}</a>
      <a [href]="appService.privacyPolicyAddress" class="create-terms-item">{{ 'external.privacyPolicy' | translate }}</a>
    </div>
  </div>
}
